unit uAktuell;

interface

uses
  System.SysUtils, System.Classes, JS, Web, WEBLib.Graphics, WEBLib.Controls,
  WEBLib.Forms, WEBLib.Dialogs, Vcl.Controls, Vcl.StdCtrls, WEBLib.StdCtrls,
  WEBLib.Buttons, uHTTPHelper, WEBLib.JSON, WEBLib.JsonData, WEBLib.REST,
  uHelper, WEBLib.ExtCtrls, uGlobal;

type
  TfrmAktuell = class(TForm)
    lbRaceName: TLabel;
    lbRaceDate: TLabel;
    WebSpeedButton1: TSpeedButton;
    btDriver1: TButton;
    WebSpeedButton2: TSpeedButton;
    btDriver2: TButton;
    WebSpeedButton3: TSpeedButton;
    btDriver3: TButton;
    WebSpeedButton4: TSpeedButton;
    btDriver4: TButton;
    WebSpeedButton5: TSpeedButton;
    btDriver5: TButton;
    lbRound: TLabel;
    lbRest: TLabel;
    tiRestTime: TTimer;
    btSprint: TButton;
    procedure btDriver1Click(Sender: TObject);
    procedure WebFormCreate(Sender: TObject);
    procedure tiRestTimeTimer(Sender: TObject);
    procedure WebFormDestroy(Sender: TObject);
  private
    { Private-Deklarationen }
  public
    { Public-Deklarationen }
    ActGpID: integer;
    ActGpIsSprint: boolean;
    ActGpStart: TDateTime;
    [async]
    function ChooseDriver(nr: integer; bt: TButton): boolean; async;
    [async]
    procedure GetNextGrandPrix; async;
    [async]
    procedure GetBet; async;
    [async]
    procedure SetBet(driverid, position: integer); async;
    function StringToDateTime(const AValue: string): TDateTime;
    procedure GetTimeDifference(Startzeit: TDateTime; var Tage, Stunden, Minuten, Sekunden: Integer);
  protected procedure LoadDFMValues; override; end;

var
  frmAktuell: TfrmAktuell;

implementation

uses
  uDriverChoice, uDriverChoice2;

{$R *.dfm}

procedure TfrmAktuell.btDriver1Click(Sender: TObject);
var
  nr: integer;
begin
  if (Sender = btDriver1) then
    nr := 1
  else if (Sender = btDriver2) then
    nr := 2
  else if (Sender = btDriver3) then
    nr := 3
  else if (Sender = btDriver4) then
    nr := 4
  else if (Sender = btDriver5) then
    nr := 5;

  ChooseDriver(nr, (Sender as TButton));
end;

function TfrmAktuell.ChooseDriver(nr: integer; bt: TButton): boolean;
var
  frmDriverChoice: TFrmDriverChoice2;
begin
  if not assigned(bt) or (nr < 1) or (nr > 5) then
    exit;


  //Driverwahl öffnen
  frmDriverChoice := TFrmDriverChoice2.Create(self);
  frmDriverChoice.Popup := False;
  frmDriverChoice.RaceID := ActGpID;
  if ActGpIsSprint then
    frmDriverChoice.Sprint := 1
  else
    frmDriverChoice.Sprint := 0;
  Await(TFrmDriverChoice2, frmDriverChoice.Load());

  try
    Await(TFrmDriverChoice2, frmDriverChoice.Execute);
    if (frmDriverChoice.ChoosenID > 0) then
    begin
      //Hier Aufruf der API - TODO
      if (frmDriverChoice.ChoosenID > 0) then
      begin
        SetBet(frmDriverChoice.ChoosenID, nr);
//      bt.Caption := frmDriverChoice.ChoosenName;
      end;

    end;

  finally
    frmDriverChoice.free;
  end;
end;

procedure TfrmAktuell.GetBet;
var
  status: integer;
  joReq, joData, jo: TJSONObject;
  ja: TJSONArray;
  i, po : integer;
begin
  //Aktuelle Wett des Benutzers holen und ggf. Namen der Fahrer eintragen
  joReq := TJSONObject.Create;
  joReq.AddPair('raceid', ActGpID);
  joReq.AddPair('is_sprint', ActGpIsSprint.ToInteger);
  status := await(integer, THTTPHelper.SendRequest(F1BET_SERVER + '/getbet/', httpPOST, joReq.ToJSON, jo));
  joReq.Free;
  if (status = HTTP_OK) then
  begin
    try
      ja := TJSONArray(jo);
      btDriver1.Caption := 'Not set';
      btDriver2.Caption := 'Not set';
      btDriver3.Caption := 'Not set';
      btDriver4.Caption := 'Not set';
      btDriver5.Caption := 'Not set';
      for i := 0 to ja.Count - 1 do
      begin
        joData := ja.Items[i] as TJSONObject;
        po := StrToInt(joData.GetJSONValue('position'));
        case po of
          1: btDriver1.Caption := joData.GetJSONValue('driver_fullname');
          2: btDriver2.Caption := joData.GetJSONValue('driver_fullname');
          3: btDriver3.Caption := joData.GetJSONValue('driver_fullname');
          4: btDriver4.Caption := joData.GetJSONValue('driver_fullname');
          5: btDriver5.Caption := joData.GetJSONValue('driver_fullname');
        end;
      end;
    finally
      ja.free;
    end;
  end else
  begin
    ShowMessage('Fehler bei GetBet, Status: ' + status.ToString);
  end;


end;

procedure TfrmAktuell.GetNextGrandPrix;
var
  jo: TJSONObject;
  status: integer;
  s: string;
  jvID, jvRound, jvRaceName, jvRaceDate, jvIsSprint, jvSprint: TJSONValue;
begin
  //Nächsten GrandPrix holen
  status := await(integer, THTTPHelper.SendRequest(F1BET_SERVER + '/nextrace/', httpGET, '', jo));

  if (Status = HTTP_OK) then
  begin
    jvID := jo.GetValue('id');
    if not assigned(jvID) then
      ShowMessage('not assigned id');

    jvRound := jo.GetValue('round');
    jvRaceName := jo.GetValue('race_name');
    jvRaceDate := jo.GetValue('race_date');
    jvIsSprint := jo.GetValue('is_sprint');
    jvSprint := jo.GetValue('sprint');

    if not assigned(jvID) or not assigned(jvRound) or not assigned(jvRaceName)
       or not assigned(jvRaceDate) or not assigned(jvIsSprint) then
    begin
      ShowMessage('Fehler bei Rückgabe der GrandPrix Daten. Es können keine Daten geändert werden');
      ActGpID := -1;
      exit;
    end;

    //TODO jvSprint noch prüfen

    ActGpID := StrToInt(jvID.Value);
    Console.log('Sprint: ' + jvIsSprint.Value);
    ActGpIsSprint := (jvIsSprint.Value = '1');
    if ActGpIsSprint then
      ActGpStart := StringToDateTime(jvSprint.Value)
    else
      ActGpStart := StringToDateTime(jvRaceDate.Value);


    lbRound.Caption := 'Nächster Grand Prix (Runde ' + jvRound.Value + ')';
    lbRaceName.Caption := jvRaceName.Value;
    btSprint.Visible := ActGpIsSprint;
    try
      if ActGpIsSprint then
        lbRaceDate.Caption := THelper.FormatDateTimeString(jvSprint.Value)
      else
        lbRaceDate.Caption := THelper.FormatDateTimeString(jvRaceDate.Value);
    except

    end;
    tiRestTime.Enabled := True;
    if (ActGpID > 0) then
      GetBet;
  end else
    ShowMessage('Fehler bei Abfrage des GrandPrix mit Status=' + status.ToString);

end;

procedure TfrmAktuell.SetBet(driverid, position: integer);
var
  joReq, jo: TJSONObject;
  status, sprint: integer;
begin
  if (driverid < 0) or (position < 1) or (position > 5) then
    exit;

  joReq := TJSONObject.Create;
  joReq.AddPair('raceid', ActGpID);
  joReq.AddPair('is_sprint', ActGpIsSprint.ToInteger);
  joReq.AddPair('driverid', driverid);
  joReq.AddPair('position', position);
  
  status := await(integer, THTTPHelper.SendRequest(F1BET_SERVER + '/bet/', httpPOST, joReq.ToJSON, jo));

  if (status = HTTP_OK) then
  begin
    GetBet;
  end else if (status = HTTP_BADREQUEST) then
  begin
    ShowMessage('BADREQUEST: ' + jo.GetJSONValue('message'));
  end else
  begin
    ShowMessage('Fehler bei Übertragung');
  end;
end;

procedure TfrmAktuell.tiRestTimeTimer(Sender: TObject);
var
  days, hours, minutes, seconds: integer;
begin
  if (ActGpID <= -1) then
    exit;

  tiRestTime.Enabled := False;

  //Wenn Zeit abgelaufen, dann nächsten GrandPrix holen
  if ((Now - ActGpStart) > 0) then
  begin
    GetNextGrandPrix;
  end;

  GetTimeDifference(ActGpStart, days, hours, minutes, seconds);
  lbRest.Caption := '(noch ' + days.ToString + ' Tage, ' + hours.ToString +
    ' Std, ' + minutes.ToString + ' Min, ' + seconds.ToString + ' Sek)';
  tiRestTime.Enabled := True;
end;

procedure TfrmAktuell.WebFormCreate(Sender: TObject);
begin
  ActGpID := -1;
  GetNextGrandPrix;


end;

procedure TfrmAktuell.WebFormDestroy(Sender: TObject);
begin
  tiRestTime.Enabled := False;
end;

procedure TfrmAktuell.GetTimeDifference(Startzeit: TDateTime; var Tage, Stunden, Minuten, Sekunden: Integer);
var
  Differenz: TDateTime;
  GesamtSekunden: Int64;
begin
  // Differenz berechnen
  Differenz := Now - Startzeit;

  // Gesamtdifferenz in Sekunden berechnen
  GesamtSekunden := Abs(Round(Differenz * 86400)); // 1 Tag = 86400 Sekunden

  // Berechnung der einzelnen Komponenten
  Tage := GesamtSekunden div 86400;
  GesamtSekunden := GesamtSekunden mod 86400;

  Stunden := GesamtSekunden div 3600;
  GesamtSekunden := GesamtSekunden mod 3600;

  Minuten := GesamtSekunden div 60;
  Sekunden := GesamtSekunden mod 60;
end;

function TfrmAktuell.StringToDateTime(const AValue: string): TDateTime;
var
  FS: TFormatSettings;
begin
  FS := TFormatSettings.Create;
  FS.DateSeparator := '-';
  FS.TimeSeparator := ':';
  FS.ShortDateFormat := 'yyyy-mm-dd';
  FS.LongTimeFormat := 'hh:nn:ss';

  Result := StrToDateTime(AValue, FS);
end;

procedure TfrmAktuell.LoadDFMValues;
begin
  inherited LoadDFMValues;

  lbRaceName := TLabel.Create(Self);
  lbRaceDate := TLabel.Create(Self);
  lbRound := TLabel.Create(Self);
  lbRest := TLabel.Create(Self);
  WebSpeedButton1 := TSpeedButton.Create(Self);
  btDriver1 := TButton.Create(Self);
  WebSpeedButton2 := TSpeedButton.Create(Self);
  btDriver2 := TButton.Create(Self);
  WebSpeedButton3 := TSpeedButton.Create(Self);
  btDriver3 := TButton.Create(Self);
  WebSpeedButton4 := TSpeedButton.Create(Self);
  btDriver4 := TButton.Create(Self);
  WebSpeedButton5 := TSpeedButton.Create(Self);
  btDriver5 := TButton.Create(Self);
  btSprint := TButton.Create(Self);
  tiRestTime := TTimer.Create(Self);

  lbRaceName.BeforeLoadDFMValues;
  lbRaceDate.BeforeLoadDFMValues;
  lbRound.BeforeLoadDFMValues;
  lbRest.BeforeLoadDFMValues;
  WebSpeedButton1.BeforeLoadDFMValues;
  btDriver1.BeforeLoadDFMValues;
  WebSpeedButton2.BeforeLoadDFMValues;
  btDriver2.BeforeLoadDFMValues;
  WebSpeedButton3.BeforeLoadDFMValues;
  btDriver3.BeforeLoadDFMValues;
  WebSpeedButton4.BeforeLoadDFMValues;
  btDriver4.BeforeLoadDFMValues;
  WebSpeedButton5.BeforeLoadDFMValues;
  btDriver5.BeforeLoadDFMValues;
  btSprint.BeforeLoadDFMValues;
  tiRestTime.BeforeLoadDFMValues;
  try
    Name := 'frmAktuell';
    Width := 276;
    Height := 480;
    Color := 16316922;
    Font.Charset := DEFAULT_CHARSET;
    Font.Color := clWhite;
    Font.Height := -12;
    Font.Name := 'Segoe UI';
    Font.Style := [];
    ParentFont := False;
    SetEvent(Self, 'OnCreate', 'WebFormCreate');
    SetEvent(Self, 'OnDestroy', 'WebFormDestroy');
    lbRaceName.SetParentComponent(Self);
    lbRaceName.Name := 'lbRaceName';
    lbRaceName.Left := 16;
    lbRaceName.Top := 61;
    lbRaceName.Width := 223;
    lbRaceName.Height := 22;
    lbRaceName.Caption := 'GrandPrix-Bezeichnung';
    lbRaceName.Color := 16316922;
    lbRaceName.Font.Charset := DEFAULT_CHARSET;
    lbRaceName.Font.Color := 2172201;
    lbRaceName.Font.Height := -19;
    lbRaceName.Font.Name := 'Tahoma, Arial, sans-serif';
    lbRaceName.Font.Style := [fsBold];
    lbRaceName.HeightPercent := 100.000000000000000000;
    lbRaceName.ParentFont := False;
    lbRaceName.Transparent := False;
    lbRaceName.WidthPercent := 100.000000000000000000;
    lbRaceDate.SetParentComponent(Self);
    lbRaceDate.Name := 'lbRaceDate';
    lbRaceDate.Left := 16;
    lbRaceDate.Top := 92;
    lbRaceDate.Width := 177;
    lbRaceDate.Height := 18;
    lbRaceDate.Caption := 'am 11.05.2038 14:00 Uhr';
    lbRaceDate.Color := 16316922;
    lbRaceDate.Font.Charset := DEFAULT_CHARSET;
    lbRaceDate.Font.Color := 2172201;
    lbRaceDate.Font.Height := -16;
    lbRaceDate.Font.Name := 'Tahoma, Arial, sans-serif';
    lbRaceDate.Font.Style := [];
    lbRaceDate.HeightPercent := 100.000000000000000000;
    lbRaceDate.ParentFont := False;
    lbRaceDate.Transparent := False;
    lbRaceDate.WidthPercent := 100.000000000000000000;
    lbRound.SetParentComponent(Self);
    lbRound.Name := 'lbRound';
    lbRound.Left := 16;
    lbRound.Top := 34;
    lbRound.Width := 221;
    lbRound.Height := 18;
    lbRound.Caption := 'N'#228'chster Grand Prix (Runde 42)';
    lbRound.Color := 16316922;
    lbRound.Font.Charset := DEFAULT_CHARSET;
    lbRound.Font.Color := 2172201;
    lbRound.Font.Height := -16;
    lbRound.Font.Name := 'Tahoma, Arial, sans-serif';
    lbRound.Font.Style := [];
    lbRound.HeightPercent := 100.000000000000000000;
    lbRound.ParentFont := False;
    lbRound.Transparent := False;
    lbRound.WidthPercent := 100.000000000000000000;
    lbRest.SetParentComponent(Self);
    lbRest.Name := 'lbRest';
    lbRest.Left := 16;
    lbRest.Top := 116;
    lbRest.Width := 241;
    lbRest.Height := 16;
    lbRest.Caption := '(noch 17 Tage, 3 Std, 17 Min und 25 Sek)';
    lbRest.Color := 16382457;
    lbRest.Font.Charset := DEFAULT_CHARSET;
    lbRest.Font.Color := 2172201;
    lbRest.Font.Height := -13;
    lbRest.Font.Name := 'Tahoma, Arial, sans-serif';
    lbRest.Font.Style := [];
    lbRest.HeightPercent := 100.000000000000000000;
    lbRest.ParentFont := False;
    lbRest.Transparent := False;
    lbRest.WidthPercent := 100.000000000000000000;
    WebSpeedButton1.SetParentComponent(Self);
    WebSpeedButton1.Name := 'WebSpeedButton1';
    WebSpeedButton1.Left := 8;
    WebSpeedButton1.Top := 142;
    WebSpeedButton1.Width := 49;
    WebSpeedButton1.Height := 50;
    WebSpeedButton1.Color := clNone;
    WebSpeedButton1.ElementClassName := 'btn';
    WebSpeedButton1.ElementFont := efCSS;
    WebSpeedButton1.HeightPercent := 100.000000000000000000;
    WebSpeedButton1.MaterialGlyph := 'looks_one';
    WebSpeedButton1.MaterialGlyphColor := 11752960;
    WebSpeedButton1.MaterialGlyphSize := 48;
    WebSpeedButton1.TabOrder := 0;
    WebSpeedButton1.WidthPercent := 100.000000000000000000;
    btDriver1.SetParentComponent(Self);
    btDriver1.Name := 'btDriver1';
    btDriver1.Left := 63;
    btDriver1.Top := 143;
    btDriver1.Width := 199;
    btDriver1.Height := 49;
    btDriver1.Anchors := [akLeft,akTop,akRight];
    btDriver1.Caption := 'Not set';
    btDriver1.ChildOrder := 3;
    btDriver1.ElementClassName := 'btn btn-primary';
    btDriver1.Font.Charset := DEFAULT_CHARSET;
    btDriver1.Font.Color := clWhite;
    btDriver1.Font.Height := -12;
    btDriver1.Font.Name := 'Tahoma, Arial, sans-serif';
    btDriver1.Font.Style := [];
    btDriver1.HeightPercent := 100.000000000000000000;
    btDriver1.ParentFont := False;
    btDriver1.WidthPercent := 100.000000000000000000;
    SetEvent(btDriver1, Self, 'OnClick', 'btDriver1Click');
    WebSpeedButton2.SetParentComponent(Self);
    WebSpeedButton2.Name := 'WebSpeedButton2';
    WebSpeedButton2.Left := 8;
    WebSpeedButton2.Top := 207;
    WebSpeedButton2.Width := 49;
    WebSpeedButton2.Height := 50;
    WebSpeedButton2.Color := clNone;
    WebSpeedButton2.ElementClassName := 'btn';
    WebSpeedButton2.ElementFont := efCSS;
    WebSpeedButton2.HeightPercent := 100.000000000000000000;
    WebSpeedButton2.MaterialGlyph := 'looks_two';
    WebSpeedButton2.MaterialGlyphColor := 11752960;
    WebSpeedButton2.MaterialGlyphSize := 48;
    WebSpeedButton2.TabOrder := 2;
    WebSpeedButton2.WidthPercent := 100.000000000000000000;
    btDriver2.SetParentComponent(Self);
    btDriver2.Name := 'btDriver2';
    btDriver2.Left := 63;
    btDriver2.Top := 207;
    btDriver2.Width := 199;
    btDriver2.Height := 49;
    btDriver2.Anchors := [akLeft,akTop,akRight];
    btDriver2.Caption := 'Not set';
    btDriver2.ChildOrder := 3;
    btDriver2.ElementClassName := 'btn btn-primary';
    btDriver2.Font.Charset := DEFAULT_CHARSET;
    btDriver2.Font.Color := clWhite;
    btDriver2.Font.Height := -12;
    btDriver2.Font.Name := 'Tahoma, Arial, sans-serif';
    btDriver2.Font.Style := [];
    btDriver2.HeightPercent := 100.000000000000000000;
    btDriver2.ParentFont := False;
    btDriver2.WidthPercent := 100.000000000000000000;
    SetEvent(btDriver2, Self, 'OnClick', 'btDriver1Click');
    WebSpeedButton3.SetParentComponent(Self);
    WebSpeedButton3.Name := 'WebSpeedButton3';
    WebSpeedButton3.Left := 8;
    WebSpeedButton3.Top := 271;
    WebSpeedButton3.Width := 49;
    WebSpeedButton3.Height := 50;
    WebSpeedButton3.Color := clNone;
    WebSpeedButton3.ElementClassName := 'btn';
    WebSpeedButton3.ElementFont := efCSS;
    WebSpeedButton3.HeightPercent := 100.000000000000000000;
    WebSpeedButton3.MaterialGlyph := 'looks_3';
    WebSpeedButton3.MaterialGlyphColor := 11752960;
    WebSpeedButton3.MaterialGlyphSize := 48;
    WebSpeedButton3.TabOrder := 4;
    WebSpeedButton3.WidthPercent := 100.000000000000000000;
    btDriver3.SetParentComponent(Self);
    btDriver3.Name := 'btDriver3';
    btDriver3.Left := 63;
    btDriver3.Top := 271;
    btDriver3.Width := 199;
    btDriver3.Height := 49;
    btDriver3.Anchors := [akLeft,akTop,akRight];
    btDriver3.Caption := 'Not set';
    btDriver3.ChildOrder := 3;
    btDriver3.ElementClassName := 'btn btn-primary';
    btDriver3.Font.Charset := DEFAULT_CHARSET;
    btDriver3.Font.Color := clWhite;
    btDriver3.Font.Height := -12;
    btDriver3.Font.Name := 'Tahoma, Arial, sans-serif';
    btDriver3.Font.Style := [];
    btDriver3.HeightPercent := 100.000000000000000000;
    btDriver3.ParentFont := False;
    btDriver3.WidthPercent := 100.000000000000000000;
    SetEvent(btDriver3, Self, 'OnClick', 'btDriver1Click');
    WebSpeedButton4.SetParentComponent(Self);
    WebSpeedButton4.Name := 'WebSpeedButton4';
    WebSpeedButton4.Left := 8;
    WebSpeedButton4.Top := 335;
    WebSpeedButton4.Width := 49;
    WebSpeedButton4.Height := 50;
    WebSpeedButton4.Color := clNone;
    WebSpeedButton4.ElementClassName := 'btn';
    WebSpeedButton4.ElementFont := efCSS;
    WebSpeedButton4.HeightPercent := 100.000000000000000000;
    WebSpeedButton4.MaterialGlyph := 'looks_4';
    WebSpeedButton4.MaterialGlyphColor := 11752960;
    WebSpeedButton4.MaterialGlyphSize := 48;
    WebSpeedButton4.TabOrder := 6;
    WebSpeedButton4.WidthPercent := 100.000000000000000000;
    btDriver4.SetParentComponent(Self);
    btDriver4.Name := 'btDriver4';
    btDriver4.Left := 63;
    btDriver4.Top := 335;
    btDriver4.Width := 199;
    btDriver4.Height := 49;
    btDriver4.Anchors := [akLeft,akTop,akRight];
    btDriver4.Caption := 'Not set';
    btDriver4.ChildOrder := 3;
    btDriver4.ElementClassName := 'btn btn-primary';
    btDriver4.Font.Charset := DEFAULT_CHARSET;
    btDriver4.Font.Color := clWhite;
    btDriver4.Font.Height := -12;
    btDriver4.Font.Name := 'Tahoma, Arial, sans-serif';
    btDriver4.Font.Style := [];
    btDriver4.HeightPercent := 100.000000000000000000;
    btDriver4.ParentFont := False;
    btDriver4.WidthPercent := 100.000000000000000000;
    SetEvent(btDriver4, Self, 'OnClick', 'btDriver1Click');
    WebSpeedButton5.SetParentComponent(Self);
    WebSpeedButton5.Name := 'WebSpeedButton5';
    WebSpeedButton5.Left := 8;
    WebSpeedButton5.Top := 399;
    WebSpeedButton5.Width := 49;
    WebSpeedButton5.Height := 50;
    WebSpeedButton5.Color := clNone;
    WebSpeedButton5.ElementClassName := 'btn';
    WebSpeedButton5.ElementFont := efCSS;
    WebSpeedButton5.HeightPercent := 100.000000000000000000;
    WebSpeedButton5.MaterialGlyph := 'looks_5';
    WebSpeedButton5.MaterialGlyphColor := 11752960;
    WebSpeedButton5.MaterialGlyphSize := 48;
    WebSpeedButton5.TabOrder := 8;
    WebSpeedButton5.WidthPercent := 100.000000000000000000;
    btDriver5.SetParentComponent(Self);
    btDriver5.Name := 'btDriver5';
    btDriver5.Left := 63;
    btDriver5.Top := 399;
    btDriver5.Width := 199;
    btDriver5.Height := 49;
    btDriver5.Anchors := [akLeft,akTop,akRight];
    btDriver5.Caption := 'Not set';
    btDriver5.ChildOrder := 3;
    btDriver5.ElementClassName := 'btn btn-primary';
    btDriver5.Font.Charset := DEFAULT_CHARSET;
    btDriver5.Font.Color := clWhite;
    btDriver5.Font.Height := -12;
    btDriver5.Font.Name := 'Tahoma, Arial, sans-serif';
    btDriver5.Font.Style := [];
    btDriver5.HeightPercent := 100.000000000000000000;
    btDriver5.ParentFont := False;
    btDriver5.WidthPercent := 100.000000000000000000;
    SetEvent(btDriver5, Self, 'OnClick', 'btDriver1Click');
    btSprint.SetParentComponent(Self);
    btSprint.Name := 'btSprint';
    btSprint.Left := 16;
    btSprint.Top := 5;
    btSprint.Width := 65;
    btSprint.Height := 25;
    btSprint.Caption := 'Sprint';
    btSprint.ChildOrder := 15;
    btSprint.ElementClassName := 'btn btn-outline-success btn-sm';
    btSprint.ElementFont := efCSS;
    btSprint.HeightPercent := 100.000000000000000000;
    btSprint.WidthPercent := 100.000000000000000000;
    tiRestTime.SetParentComponent(Self);
    tiRestTime.Name := 'tiRestTime';
    tiRestTime.Enabled := False;
    SetEvent(tiRestTime, Self, 'OnTimer', 'tiRestTimeTimer');
    tiRestTime.Left := 208;
    tiRestTime.Top := 152;
  finally
    lbRaceName.AfterLoadDFMValues;
    lbRaceDate.AfterLoadDFMValues;
    lbRound.AfterLoadDFMValues;
    lbRest.AfterLoadDFMValues;
    WebSpeedButton1.AfterLoadDFMValues;
    btDriver1.AfterLoadDFMValues;
    WebSpeedButton2.AfterLoadDFMValues;
    btDriver2.AfterLoadDFMValues;
    WebSpeedButton3.AfterLoadDFMValues;
    btDriver3.AfterLoadDFMValues;
    WebSpeedButton4.AfterLoadDFMValues;
    btDriver4.AfterLoadDFMValues;
    WebSpeedButton5.AfterLoadDFMValues;
    btDriver5.AfterLoadDFMValues;
    btSprint.AfterLoadDFMValues;
    tiRestTime.AfterLoadDFMValues;
  end;
end;

end.
